import type { ChatDomain } from '../hooks/useChat';

interface DomainOption {
  value: ChatDomain;
  label: string;
  subtitle: string;
}

const DOMAINS: readonly DomainOption[] = [
  { value: 'faa-part145', label: 'FAA Part 145',  subtitle: 'Repair Stations' },
  { value: 'faa-part121', label: 'FAA Part 121',  subtitle: 'Air Carrier Ops' },
  { value: 'easa-part145', label: 'EASA Part-145', subtitle: 'EU Maintenance' },
  { value: 'icao-annex6',  label: 'ICAO Annex 6',  subtitle: 'SARPs (gated)' },
];

interface DomainPickerProps {
  value: ChatDomain;
  onChange: (d: ChatDomain) => void;
  disabled?: boolean;
}

export function DomainPicker({ value, onChange, disabled }: DomainPickerProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Regulatory domain"
      className="flex flex-wrap gap-2"
      data-testid="aviation-demo-chat-domain-picker"
    >
      {DOMAINS.map((d) => {
        const selected = d.value === value;
        return (
          <button
            key={d.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(d.value)}
            data-testid={`aviation-demo-chat-domain-${d.value}`}
            className={[
              'px-3 py-2 rounded-xl text-left transition-colors',
              'border border-gray-200 dark:border-slate-700',
              'focus:outline-none focus:ring-2 focus:ring-sky-500',
              selected
                ? 'bg-sky-50 dark:bg-sky-900/30 border-sky-500 dark:border-sky-500'
                : 'bg-white/60 dark:bg-slate-900/60 hover:bg-gray-50 dark:hover:bg-slate-800',
              disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
            ].join(' ')}
          >
            <div className="text-sm font-semibold text-gray-900 dark:text-slate-100">{d.label}</div>
            <div className="text-xs text-gray-500 dark:text-slate-400">{d.subtitle}</div>
          </button>
        );
      })}
    </div>
  );
}
